(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
==========================================================================
utility functions
==========================================================================
*/
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
  var date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  var expires = '; expires=' + date.toGMTString();
  document.cookie = name + '=' + value + expires + ';path=/';
}

function getParam(p) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.search;

  var match = RegExp('[?&]' + p + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

function getParams() {
  var query = window.location.search;

  return query ? (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
    var _param$split = param.split('='),
        _param$split2 = _slicedToArray(_param$split, 2),
        key = _param$split2[0],
        value = _param$split2[1];

    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
    return params;
  }, {}) : false;
}

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function superscript() {
  jQuery(function ($) {
    $('p,h1,h2,h3,h4,h5,h6,li,a,span,td,th,i,b,u,em,strong,del,label,small').contents().filter(function () {
      return this.nodeType === 3;
    }).replaceWith(function () {
      return this.nodeValue.replace(/[®™️]/g, '<sup>$&</sup>');
    });
  });
}

function urlDecode(str) {
  return decodeURIComponent((str + '').replace(/\+/g, '%20'));
}

/*
==========================================================================
class utility
==========================================================================
*/

var RezberryClass = function () {
  _createClass(RezberryClass, [{
    key: 'addListeners',


    /*
    ==========================================================================
    listeners
    ==========================================================================
    */
    value: function addListeners() {
      for (var selector in this.listeners) {
        this.addListener(selector, this.listeners[selector]);
      }
    }
  }, {
    key: 'addListener',
    value: function addListener(selector, listener) {
      if (listener instanceof Array) {
        for (var item in listener) {
          if (!listener.hasOwnProperty(item)) continue;
          this.addListener(selector, listener[item]);
        }
      } else {
        this[selector].on(listener.ev, this[listener.func].bind(this));
      }
    }

    /*
    ==========================================================================
    selectors
    ==========================================================================
    */

  }, {
    key: 'addSelectors',
    value: function addSelectors() {
      for (var name in this.selectors) {
        this.addSelector(name, this.selectors[name]);
      }
    }
  }, {
    key: 'addSelector',
    value: function addSelector(name, selector) {
      this['$' + name] = this.$scope.find(selector);
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }]);

  function RezberryClass(scope) {
    _classCallCheck(this, RezberryClass);

    this.$scope = jQuery(scope);
  }

  return RezberryClass;
}();

/*
==========================================================================
export
==========================================================================
*/


exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.getParam = getParam;
exports.getParams = getParams;
exports.debounce = debounce;
exports.superscript = superscript;
exports.urlDecode = urlDecode;
exports.RezberryClass = RezberryClass;

},{}],2:[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utilities = require('../../assets/src/js/utilities');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RezberrySolutionInsightsArchive = function (_RezberryClass) {
  _inherits(RezberrySolutionInsightsArchive, _RezberryClass);

  _createClass(RezberrySolutionInsightsArchive, [{
    key: 'searchInsights',


    /*
    ==========================================================================
    search
    ==========================================================================
    */
    value: function searchInsights(e) {
      this.$loading.show();
      this.keyword = $(e.target).val();
      this.fetchPosts(this.restBase, {
        type: this.typeFilter,
        industry: this.industriesList,
        service: this.servicesList,
        s: this.keyword,
        page: 1,
        postType: 'any'
      }, false);
    }

    /*
    ==========================================================================
    filter
    ==========================================================================
    */

  }, {
    key: 'filterIndustries',
    value: function filterIndustries(e) {
      this.$loading.show();
      var indVal = $(e.target).val();
      if (this.industriesList.includes(indVal)) {
        this.industriesList = $.grep(this.industriesList, function (value) {
          return value != indVal;
        });
      } else {
        this.industriesList.push(indVal);
      }
      this.updateUrlParams('industry', indVal, this.industriesList);
      this.updateActiveFiltersBar($(e.target));
      this.fetchPosts(this.restBase, {
        type: this.typeFilter,
        industry: this.industriesList,
        service: this.servicesList,
        s: this.keyword,
        page: 1,
        postType: 'any'
      }, false);
    }
  }, {
    key: 'filterServices',
    value: function filterServices(e) {
      this.$loading.show();
      var serVal = $(e.target).val();
      if (this.servicesList.includes(serVal)) {
        this.servicesList = $.grep(this.servicesList, function (value) {
          return value != serVal;
        });
      } else {
        this.servicesList.push(serVal);
      }
      this.updateUrlParams('service', serVal, this.servicesList);
      this.updateActiveFiltersBar($(e.target));
      this.fetchPosts(this.restBase, {
        type: this.typeFilter,
        industry: this.industriesList,
        service: this.servicesList,
        s: this.keyword,
        page: 1,
        postType: 'any'
      }, false);
    }
  }, {
    key: 'setActiveFilters',
    value: function setActiveFilters() {
      var urlParams = new URLSearchParams(window.location.search);
      this.activeIndustries = urlParams.has('industry') ? this.convertParamToArray(urlParams.get('industry')) : [];
      var activeIndArr = this.activeIndustries;
      if (this.activeIndustries.length > 0) {
        $('#insight-topics-industry input[type="checkbox"]').each(function () {
          if (activeIndArr.indexOf($(this).val()) > -1) {
            $(this).prop('checked', true);
          }
        });
      }
      this.activeServices = urlParams.has('service') ? this.convertParamToArray(urlParams.get('service')) : [];
      var activeSerArr = this.activeServices;
      if (this.activeServices.length > 0) {
        $('#insight-topics-service input[type="checkbox"]').each(function () {
          if (activeSerArr.indexOf($(this).val()) > -1) {
            $(this).prop('checked', true);
          }
        });
      }
      this.fetchPosts(this.restBase, {
        type: this.typeFilter,
        industry: this.industriesList,
        service: this.servicesList,
        page: 1,
        postType: 'any'
      }, false);
    }
  }, {
    key: 'updateActiveFiltersBar',
    value: function updateActiveFiltersBar(activeFilter) {
      if (this.industriesList || this.servicesList) {
        if (this.industriesList.length > 0 || this.servicesList.length > 0) {
          this.$activeFiltersBar.show();
          if (activeFilter) {
            if ($(activeFilter).is(':checked')) {
              this.$activeFiltersList.append('<span data-field-id="' + $(activeFilter).attr('id') + '" class="active-filter-item">' + $(activeFilter).siblings('span').html() +
              // '<button type="button" class="active-filter-remove" data-slug="'+ $(activeFilter).val() +'">Remove ' + $(activeFilter).siblings('span').html() + ' filter</button>' +
              '</span>');
            } else {
              this.$activeFiltersList.find('.active-filter-item[data-field-id="' + $(activeFilter).attr('id') + '"]').remove();
            }
          } else {
            $('.dropdown-cbx input[type=checkbox]:checked').each(function () {
              $('.t-solution-insights-active-filters-list').append('<span data-field-id="' + $(this).attr('id') + '" class="active-filter-item">' + $(this).siblings('span').html() +
              // '<button type="button" class="active-filter-remove" data-slug="'+ $(this).val() +'">Remove ' + $(this).siblings('span').html() + ' filter</button>' +
              '</span>');
            });
          }
        } else {
          this.$activeFiltersBar.hide();
          this.$activeFiltersList.find('.active-filter-item[data-field-id="' + $(activeFilter).attr('id') + '"]').remove();
        }
      } else {
        this.$activeFiltersBar.hide();
      }
    }
  }, {
    key: 'resetFilters',
    value: function resetFilters() {
      $('#insight-topics-industry .dropdown-cbx input[type="checkbox"]:checked').each(function () {
        $(this).click();
      });
      $('#insight-topics-service .dropdown-cbx input[type="checkbox"]:checked').each(function () {
        $(this).click();
      });
    }
    /*
    ==========================================================================
    update query parameters
    ==========================================================================
    */

  }, {
    key: 'updateUrlParams',
    value: function updateUrlParams(param, val, list) {
      var urlParams = new URLSearchParams(window.location.search);
      var changeUrl = false;

      if (urlParams) {
        if (list && list.length > 0 && urlParams.get(param) != list.join(' ')) {
          urlParams.set(param, list.join(' '));
          changeUrl = true;
        } else {
          urlParams.delete(param);
          changeUrl = true;
        }
        $('#filter-types .dropdown-item').each(function () {
          var typeLink = '/solution-insights/' + $(this).data('slug');
          var newTypeLink = typeLink + '?' + urlParams.toString();
          $(this).attr('href', newTypeLink);
        });
      } else {
        urlParams.set(param, list);
        changeUrl = true;
      }
      if (changeUrl) {
        if (urlParams.toString().length > 0) {
          history.pushState({}, '', location.pathname + '?' + urlParams.toString());
        } else {
          history.pushState({}, '', '' + location.pathname);
        }
      }
    }

    /*
    ==========================================================================
    view more
    ==========================================================================
    */

  }, {
    key: 'viewMore',
    value: function viewMore(e) {
      e.preventDefault();
      this.page++;
      this.$loading.show();
      this.fetchPosts(this.restBase, {
        type: this.typeFilter,
        industry: this.industriesList,
        service: this.servicesList,
        page: this.page,
        postType: 'any'
      }, true);
    }

    /*
    ==========================================================================
    fetch posts
    ==========================================================================
    */

  }, {
    key: 'fetchPosts',
    value: function fetchPosts(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var paginate = arguments[2];

      url = 'https://' + window.location.host + '/wp-json/rez/posts-insights';
      if (Object.keys(params).length > 0) {
        url += '?' + $.param(params);
      }

      if (url != undefined) {
        $.get(url, function (data, status, xhr) {
          // alert(status)
          this.totalPages = xhr.getResponseHeader('X-WP-TotalPages');
          this.handleFetchPosts(data, paginate);
        }.bind(this)).fail(function (data) {
          this.handleFetchPosts(data, paginate);
          // this.show(this.$noResults)
          // // this.$posts.hide()
          // this.$loading.hide()
        }.bind(this));
      }
    }
  }, {
    key: 'handleFetchPosts',
    value: function handleFetchPosts(data, paginate) {

      if (!data) {
        // TODO: check
        this.$loading.hide();
        return;
      }
      if (this.totalPages > 1 && this.page != this.totalPages) {
        this.show(this.$viewMore);
      } else {
        this.hide(this.$viewMore);
      }

      if (paginate) {
        this.$posts.append(data);
      } else {
        this.$posts.html('').append(data);
      }
      if (!data.length) {
        this.show(this.$noResults);
      } else {
        this.$posts.removeClass('temp-hidden');
        this.hide(this.$noResults);
      }

      this.$loading.hide();
    }

    /*
    ==========================================================================
    utility
    ==========================================================================
    */

  }, {
    key: 'hide',
    value: function hide(el) {
      el.addClass('d-none');
    }
  }, {
    key: 'show',
    value: function show(el) {
      el.removeClass('d-none');
    }
  }, {
    key: 'convertParamToArray',
    value: function convertParamToArray(param) {
      if (param) {
        return param.split(' ');
      }
    }

    /*
    ==========================================================================
    init
    ==========================================================================
    */

  }, {
    key: 'selectors',
    get: function get() {
      return {
        noResults: '.t-solution-insights-no-results',
        posts: '.t-solution-insights-posts',
        viewMore: '.t-solution-insights-view-more .btn-wrap',
        industriesCbx: '#insight-topics-industry .dropdown-cbx input[type="checkbox"]',
        servicesCbx: '#insight-topics-service .dropdown-cbx input[type="checkbox"]',
        activeFiltersList: '.t-solution-insights-active-filters-list',
        clearAllFilters: '.filter-clear',
        searchInput: '.t-solution-insights-search #keywords'
      };
    }
  }, {
    key: 'listeners',
    get: function get() {
      return {
        '$viewMore': [{
          ev: 'click',
          func: 'viewMore'
        }],
        '$industriesCbx': [{
          ev: 'change',
          func: 'filterIndustries'
        }],
        '$servicesCbx': [{
          ev: 'change',
          func: 'filterServices'
        }],
        '$clearAllFilters': [{
          ev: 'click',
          func: 'resetFilters'
        }],
        '$searchInput': [{
          ev: 'keyup',
          func: 'searchInsights'
        }]
      };
    }
  }]);

  function RezberrySolutionInsightsArchive(scope) {
    _classCallCheck(this, RezberrySolutionInsightsArchive);

    // parent methods
    var _this = _possibleConstructorReturn(this, (RezberrySolutionInsightsArchive.__proto__ || Object.getPrototypeOf(RezberrySolutionInsightsArchive)).call(this, scope));

    _this.addSelectors();
    _this.addListeners();
    // this.setActiveFilters()

    var urlParams = new URLSearchParams(window.location.search);
    var urlParts = window.location.pathname.split('/');

    if (urlParams) {
      _this.industriesList = urlParams.has('industry') ? _this.convertParamToArray(urlParams.get('industry')) : [];
      _this.servicesList = urlParams.has('service') ? _this.convertParamToArray(urlParams.get('service')) : [];
    }

    _this.$loading = $('.loading');
    _this.$activeFiltersBar = $('.t-solution-insights-active-filters');
    _this.typeFilter = 'solution-insights';
    _this.page = 1;
    _this.restBase = 'https://' + window.location.host + '/wp-json/rez/posts-insights';
    _this.totalPages = 0;
    _this.postType = 'any';
    _this.activeIndustries = [];
    _this.activeServices = [];
    _this.setActiveFilters();
    _this.updateActiveFiltersBar();

    return _this;
  }

  return RezberrySolutionInsightsArchive;
}(_utilities.RezberryClass);

$(document).ready(function () {
  new RezberrySolutionInsightsArchive('.t-solution-insights');

  $('body').on('click', '.dropdown-menu-multiselect', function (e) {
    $(this).parent().is('.show') && e.stopPropagation();
  });
});

},{"../../assets/src/js/utilities":1}]},{},[2]);
